import { render } from "./AlertRulesPage.vue?vue&type=template&id=67a9b7c9"
import script from "./AlertRulesPage.vue?vue&type=script&lang=js"
export * from "./AlertRulesPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__